module.exports = __webpack_public_path__ + "static/img/tly.b2de9ff9.png";